import React, { Component, Fragment } from 'react';
import { BeatLoader } from 'react-spinners';
import ReactTable from 'react-table';
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError } from '../../../server/util';
import { get, postResponse, patch, post, put, postWithHeaders, putWithHeadersResponse } from "../../../server/actions";
import { date_format } from '../../../server/constants'
import moment from 'moment';
const customManageUsersStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
class ContactUS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showList: true,
            expanded: {},
            recList: [],
            loading: false,
            disablebtn: false,
            requestObj: {
                issuedesc: '',
                issue: '',

                attachments: [],
                comments: [],
                status: '',
                title: '',
                Comment: '',
                rowID: 0,
                createdBy: '',
                assigneeId: 0
            },
            newComment: {},
            typeCode: [],
            statusCode: [],
            editList: false,

            loggedUser: JSON.parse(sessionStorage.getItem('loggedInUserInfo', 'ROLE')),
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.selectType = this.selectType.bind(this);
        this.selectStatus = this.selectStatus.bind(this);
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getStatusData();
        this.getTypeData();
        this.getFindByMealSchool();
    }
    getFindByMealSchool = () => {
        this.setState({ loading: true })
        get(`/supportRequests/search/findByMealSchoolSchoolId?mealSchoolId=${this.state.loggedUser.schoolId}&access_token=`).then((response) => {
            this.setState({ loading: false });
            console.log("Response:::::", response);
            if (!response.ok) {
                throw Error(response);
            }
            return response.json();

        }).then(data => {
            //console.log("Data:::::",data);
            console.log("Data:::::", data._embedded.supportRequests);
            let supportData = data._embedded.supportRequests.sort((a, b) => b.createdOn.localeCompare(a.createdOn));
            supportData.map((srItem, i) => {
                supportData[i]["createdOn"] = moment(srItem.createdOn).format('MM/DD/YYYY hh:mm a');
                this.state.typeCode.map((tCode) => {
                    if (tCode.typeCode == srItem.typeCode) {
                        supportData[i]["typeValue"] = tCode.description;
                    }
                });

                this.state.statusCode.map((sCode) => {
                    if (sCode.statusCode == srItem.statusCode) {
                        supportData[i]["statusValue"] = sCode.description;
                    }
                });
                /* if(!supportData[i]["sendUpdateToCustomer"]){
                    supportData[i]["comments"] = "";
                } */
            });
            console.log("supportData:::::", supportData);
            this.setState({ recList: supportData });
            console.log("recList:::::", this.state.recList);
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('recList', error);
            }
        )
    }


    selectType = (e) => {
        let idx = e.target.selectedIndex;
        this.state.requestObj.issue = e.target.options[idx].value;
        //let dataset = e.target.options[idx].dataset;
        console.log('this.state.requestObj.issue::::: ', this.state.requestObj.issue);
    }
    selectStatus = (e) => {
        let idx = e.target.selectedIndex;
        this.state.requestObj.status = e.target.options[idx].value;
        //let dataset = e.target.options[idx].dataset;
        console.log('this.state.requestObj.status::::: ', this.state.requestObj.status);
    }


    getStatusData = () => {
        this.setState({ loading: true })
        get(`/supportRequest/status?access_token=`).then((response) => {
            this.setState({ loading: false });
            console.log("Response:::::", response);
            if (!response.ok) {
                throw Error(response.statusMessage);
            }
            return response.json();
        }).then(data => {
            this.setState({ statusCode: data });
            console.log("StatusResult:::::", this.state.statusCode);
        }).catch(
            (error) => {
                this.setState({ loading: false });

                console.log('status', error);
            }
        )
    }
    getTypeData = () => {
        this.setState({ loading: true })
        get(`/supportRequest/type?access_token=`).then((response) => {
            this.setState({ loading: false });
            console.log("Response:::::", response);
            if (!response.ok) {
                throw Error(response.typeMessage);
            }
            return response.json();
        }).then(data => {
            this.setState({ typeCode: data });
            console.log("TypeResult:::::", this.state.typeCode);
        }).catch(
            (error) => {
                this.setState({ loading: false });

                console.log('type', error);
            }
        )
    }

    getAttentionNeededStatusCode = () => {
        return (this.state.statusCode.find(r => {
            return r.description == 'Attention Needed'
        }) || {}).statusCode;
    }

    handleSave = (e) => {
        this.state.requestObj.status = document.getElementById("selectStatus").value;
        e.preventDefault();

        let headers = {
            "Content-Type": "multipart/form-data",
            "Accept": "application/json"
        };

        let user = this.state.loggedUser

        let data = new FormData();
        if (this.state.newComment.attachments && this.state.newComment.attachments.length > 0) {
            data.append('file', this.state.newComment.attachments[0]);
        }

        // A response from the school admin is never emailed out, so flag the ticket
        // as Attention Needed to surface it to super admins in Support Management.
        const attentionNeededCode = this.getAttentionNeededStatusCode();
        let formData = {
            "id": this.state.requestObj.rowID,
            "schoolId": user.schoolId,
            "schoolName": user.schoolName,
            "typeCode": this.state.requestObj.issue,
            "statusCode": attentionNeededCode || this.state.requestObj.status,
            "title": this.state.requestObj.title,
            "description": this.state.requestObj.issuedesc,
            "comments": this.state.newComment.description,
            "sendUpdateToCustomer": false
        }
        if ((this.state.newComment.description || '').trim() === '') {
            _addNotificationError('Please Add Comment.', this);
            return false;
        }
        data.append('body', JSON.stringify(formData));
        console.log("Form Data:::: ", JSON.stringify(formData));
        this.disable_enableBtn(true);
        putWithHeadersResponse('/supportRequest?access_token=', data, undefined)
            .then((response) => {
                console.log("PUT Response::::", response);
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((data) => {
                _addNotification('Successfully updated request details.', this);
                const _requestObj = {};
                _requestObj.rowID = 0;
                _requestObj.attachments = [];
                _requestObj.comments = [];
                _requestObj.issue = '';
                _requestObj.issuedesc = '';
                _requestObj.status = '';
                _requestObj.statusdesc = '';
                _requestObj.issuecomment = '';
                _requestObj.title = '';
                _requestObj.createdBy = '';

                this.setState({ issuedesc: '', issue: '', loading: false, newComment: {}, showList: true, editList: false, requestObj: { ..._requestObj } });
                this.disable_enableBtn();
                this.getFindByMealSchool();
                this.disable_enableBtn(false);
            }).catch(error => {
                this.setState({ loading: false });
                _addNotificationError('Could not updated request details.', this);
                console.log('update request response', error)
            });
    }

    handleSubmit(e) {
        this.state.requestObj.status = document.getElementById("selectStatus").value;
        const { attachments } = this.state.requestObj;
        e.preventDefault();
        let headers = {
            "Content-Type": "multipart/form-data",
            "Accept": "application/json"
        };
        let user = this.state.loggedUser
        let data = new FormData();
        if (attachments.length > 0) {
            data.append('file', attachments[0]);
        }
        const statusCode = this.getAttentionNeededStatusCode();
        let formData = {
            "schoolId": user.schoolId,
            "schoolName": user.schoolName,
            "typeCode": this.state.requestObj.issue,
            "statusCode": statusCode,//this.state.requestObj.status,
            "title": this.state.requestObj.title,
            "description": this.state.requestObj.issuedesc,
            "comments": this.state.requestObj.issuecomment,
            "sendUpdateToCustomer": false,
            "assigneeId": this.state.requestObj.assigneeId
        }

        if ((this.state.requestObj.issue || '').trim() === '') {
            _addNotificationError('Please select Issue type.', this);
            return false;
        }
        if ((this.state.requestObj.title || '').trim() === '') {
            _addNotificationError('Please enter Title.', this);
            return false;
        }
        if ((this.state.requestObj.issuedesc || '').trim() === '') {
            _addNotificationError('Please enter Description.', this);
            return false;
        }

        data.append('body', JSON.stringify(formData));
        console.log("Form Data:::: ", JSON.stringify(formData));
        this.disable_enableBtn(true);
        post('/supportRequest?access_token=', data).then((response) => {
            console.log("Response::::", response);
            if (!response.ok) {
                throw Error(response.statusMessage);
            }
            return response;
        }).then(data => {
            console.log("Response::::", data);
            _addNotification('Thank you! Our support team will contact you soon.', this);
            this.setState({ issuedesc: '', issue: '', loading: false, newComment: {}, showList: true });
            this.disable_enableBtn();
            this.getFindByMealSchool();
        }).catch(
            (error) => {
                this.setState({ loading: false });
                _addNotificationError('Please try again!', this);
                this.disable_enableBtn();
            }
        )
        return false;
    }
    getSupportRequestRec = (recId) => {
        this.setState({ loading: true });
        get(`/supportRequests/${recId}?access_token=`).then((response) => {
            this.setState({ loading: false });
            console.log("Response:::::", response);
            if (!response.ok) {
                throw Error(response);
            }
            return response.json();
        }).then(data => {
            this.getSupportRequestHistory(recId, data);
            this.setState({ loading: false });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('recList', error);
            }
        );
    }

    getSupportRequestHistory = (recId, latestRec) => {
        this.setState({ loading: true });
        get(`/supportRequest/${recId}/history?access_token=`).then((response) => {
            this.setState({ loading: false });
            console.log("Response:::::", response);
            if (!response.ok) {
                throw Error(response);
            }
            return response.json();
        }).then(data => {
            const { requestObj } = this.state;
            if ((data).length > 0) {
                (data.reverse()).map((rec, i) => {
                    requestObj.comments.push({ ...rec });
                    /*if(i==0){
                        requestObj.issuedesc=rec.description;
                        requestObj.downloadUri=rec.downloadUri||'';
                    }else{
                        requestObj.comments.push({...rec});
                    } */
                });
                //requestObj.comments.push({...latestRec});

            }
            //else{
            //requestObj.issuedesc=latestRec.description;
            // }             
            console.log("Comments::::::", requestObj.comments);
            requestObj.rowID = Number(recId);
            requestObj.issue = latestRec.typeCode;
            requestObj.status = latestRec.statusCode;
            requestObj.title = latestRec.title;
            requestObj.issuedesc = latestRec.description;
            requestObj.downloadUri = latestRec.downloadUri;
            requestObj.createdBy = latestRec.createdBy;
            requestObj.assigneeId = latestRec.assigneeId;

            // requestObj.editAttachments.push({"name":row.fileName});
            this.setState({ requestObj: { ...requestObj }, editList: true, showList: false });


            data._embedded.supportRequests.map((srItem, i) => {
                this.state.typeCode.map((tCode) => {
                    if (tCode.typeCode == srItem.typeCode) {
                        data._embedded.supportRequests[i]["typeValue"] = tCode.description;
                    }
                });

                this.state.statusCode.map((sCode) => {
                    if (sCode.statusCode == srItem.statusCode) {
                        data._embedded.supportRequests[i]["statusValue"] = sCode.description;
                    }
                });
            });
            this.setState({ recList: data._embedded.supportRequests });
            console.log("recList:::::", this.state.recList);
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('recList', error);
            }
        )

    }

    showReqestForm = () => {
        const _requestObj = {};
        _requestObj.rowID = 0;
        _requestObj.attachments = [];
        _requestObj.comments = [];
        _requestObj.issue = '';
        _requestObj.issuedesc = '';
        _requestObj.status = '';
        _requestObj.statusdesc = '';
        _requestObj.issuecomment = '';
        _requestObj.title = '';
        _requestObj.createdBy = '';
        _requestObj.assigneeId = 0;

        this.setState({ editList: false, showList: false, newComment: {}, requestObj: { ..._requestObj } });
    }
    cancelRequestForm = () => {
        const _requestObj = {};
        _requestObj.rowID = 0;
        _requestObj.attachments = [];
        _requestObj.comments = [];
        _requestObj.editAttachments = [];
        _requestObj.issue = '';
        _requestObj.issuedesc = '';
        _requestObj.status = '';
        _requestObj.statusdesc = '';
        _requestObj.issuecomment = '';
        _requestObj.title = '';
        _requestObj.createdBy = '';
        _requestObj.assigneeId = 0;
        this.setState({ editList: false, showList: true, newComment: {}, requestObj: { ..._requestObj } });
    }
    editReqestForm = (row) => {
        const recId = row._links.self.href.split("/").pop();
        this.getSupportRequestRec(recId);

    }
    disable_enableBtn = (isDisable = false) => {
        return new Promise((resolve, reject) => {
            this.setState({ disablebtn: isDisable });
            resolve(true);
        });
    }
    renderNewRequestForm = () => {
        const { disablebtn } = this.state;
        const { requestObj, loggedUser, newComment } = this.state;
        console.log("requestObj:::::", requestObj);
        return (<div className='row'>
            <div className='col-md-offset-3 col-md-6'>
                <form>
                    <div className="form-group">
                        <label>Reporter : </label> &nbsp;&nbsp;{this.state.editList ?
                            <label>{requestObj.createdBy}</label> : <label>{loggedUser.username}</label>}
                    </div>

                    <div className="form-group col-md-6" style={{ margin: '0px 0px 0px -14px' }}>
                        <label htmlFor="issue">Issue:</label>
                        {this.state.editList ? <select className="form-control" value={this.state.requestObj.issue} disabled={(requestObj.rowID || 0) > 0}>
                            <option value="">Select Type</option>
                            {this.state.typeCode &&
                                this.state.typeCode.map((item, index) => {
                                    return <option value={item.typeCode} disabled={this.state.editList ? true : false}>{item.description}</option>;
                                })}
                        </select> : <select className="form-control" onChange={this.selectType} disabled={(requestObj.rowID || 0) > 0}>
                            <option value="">Select Type</option>
                            {this.state.typeCode &&
                                this.state.typeCode.map((item, index) => {
                                    return <option value={item.typeCode} disabled={this.state.editList ? true : false}>{item.description}</option>;
                                })}
                        </select>}
                    </div>

                    <div className="form-group col-md-6" style={{ margin: '0px 0px 0px -14px' }}>
                        <label htmlFor="status">Status:</label>
                        <select id="selectStatus" value={this.state.requestObj.status} className="form-control" onChange={this.selectStatus} disabled style={{ width: '260px' }}>

                            {this.state.statusCode &&
                                this.state.statusCode.map((item, index) => {
                                    return <option value={item.statusCode} disabled={item.description != 'New' ? true : false}>{item.description}</option>
                                    //return (item.description == 'New') ?<option value={item.statusCode}>{item.description}</option>:''

                                })}
                        </select>
                    </div>


                    <div className="form-group">
                        <label>Title: </label>
                        <textarea className="form-control" rows={1} maxLength={300} id="issue-title" value={this.state.requestObj.title} disabled={(requestObj.rowID || 0) > 0} required
                            placeholder="Please provide issue title" spellcheck="false"
                            onChange={(e) => {
                                this.state.requestObj.title = e.target.value;
                                this.setState({ requestObj: { ...this.state.requestObj } });
                            }}></textarea>

                    </div>
                    <div className="form-group">
                        <label htmlFor="issuedesc">Description:</label>
                        <textarea className="form-control" rows={5} maxLength={2000} id="issue-desc" value={this.state.requestObj.issuedesc} disabled={(requestObj.rowID || 0) > 0} required
                            placeholder="Please provide a short description of issue or inquiry" spellcheck="false"
                            onChange={(e) => {
                                this.state.requestObj.issuedesc = e.target.value;
                                this.setState({ requestObj: { ...this.state.requestObj } });
                            }}></textarea>

                    </div>
                    <div className='form-group'>
                        <div className='row'>
                            {this.state.requestObj.downloadUri && <div className='col-md-12 text-right'>
                                <a title="Click to Download File" href={this.state.requestObj.downloadUri}
                                    target='_blank'  ><i className="fa fa-paperclip" aria-hidden="true"></i> Attachment</a>
                            </div>}
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            {
                                (requestObj.rowID || 0) > 0 ?
                                    <Fragment>
                                        {
                                            requestObj.comments.length > 0 &&
                                            requestObj.comments.map((comm, i) => {
                                                //if(comm.sendUpdateToCustomer || requestObj.comments.length - 1 == i)
                                                if (comm.sendUpdateToCustomer) {
                                                    return <div className="well well-sm"><div className='row'>
                                                        <div className='col-md-12 form-group'>
                                                            <label htmlFor={`issuecomment-${i}`} >Comments:</label>
                                                            <textarea className='form-control' disabled id={`issuecomment-${i}`}
                                                                value={comm.comments}
                                                            ></textarea>
                                                        </div>
                                                        <div className='col-md-12 from-group'>
                                                            <div className='row'>
                                                                <div className='col-md-12' style={{ fontSize: '10px' }}>
                                                                    <div className='row'>
                                                                        <div className='col-md-8'>
                                                                            <label>Comment By:</label> <label>{comm.modifiedBy}</label>
                                                                        </div>
                                                                        <div className='col-md-4 text-right'><label>On: {moment(comm.modifiedOn, 'YYYY-MM-DDThh:mm:ss').isValid() && moment(comm.modifiedOn, 'YYYY-MM-DDThh:mm:ss').format(`${date_format()} hh:mm A`)}</label></div>
                                                                    </div>
                                                                </div>
                                                                {comm.downloadUri && <div className='col-md-12 text-right'>
                                                                    <a title="Click to Download File" href={comm.downloadUri}
                                                                        target='_blank'
                                                                    ><i className="fa fa-paperclip" aria-hidden="true"></i> Attachment</a>
                                                                </div>}
                                                            </div>

                                                        </div>
                                                    </div></div>
                                                }
                                                return null;
                                            })
                                        }
                                        {(this.state.editList) ? this.state.statusCode.filter((status) => {
                                            return status.statusCode == requestObj.status;
                                        })[0].description != 'Closed' && <div className="form-group">
                                                <label htmlFor="issuecomment" >Comments:</label>
                                                <textarea className="form-control" rows={3} maxLength={2000} id="comments" value={newComment.description} required
                                                    placeholder="Please provide a short comment of issue or inquiry" spellcheck="false"
                                                    onChange={(e) => {
                                                        this.state.newComment.description = e.target.value;
                                                        this.setState({ newComment: { ...this.state.newComment } });
                                                    }}></textarea>
                                            </div> : <div className="form-group">
                                            <label htmlFor="issuecomment" >Comments:</label>
                                            <textarea className="form-control" rows={3} maxLength={2000} id="comments" value={newComment.description} required
                                                placeholder="Please provide a short comment of issue or inquiry" spellcheck="false"
                                                onChange={(e) => {
                                                    this.state.newComment.description = e.target.value;
                                                    this.setState({ newComment: { ...this.state.newComment } });
                                                }}></textarea>
                                        </div>}
                                    </Fragment>
                                    : null
                            }
                        </div>
                    </div>
                    <div className='row'>

                        {(this.state.editList) ? this.state.statusCode.filter((status) => {
                            return status.statusCode == requestObj.status;
                        })[0].description != 'Closed' && <div className='col-md-12 form-group'>
                                <label htmlFor="attachment">Attachment:</label>
                                <input type='file' id="attachment" className="form-control"
                                    onChange={(e) => {
                                        if ((e.target.files || []).length <= 0) {
                                            e.target.value = '';
                                            return false;
                                        }
                                        const { requestObj, newComment } = this.state
                                        if (requestObj.rowID > 0) {
                                            newComment.attachments = [e.target.files[0]];
                                            this.setState({ newComment: { ...newComment } });
                                        } else {
                                            requestObj.attachments = [e.target.files[0]];
                                            this.setState({ requestObj: { ...requestObj } });
                                        }


                                        return true;

                                    }} />
                            </div> : <div className='col-md-12 form-group'>
                            <label htmlFor="attachment">Attachment:</label>
                            <input type='file' id="attachment" className="form-control"
                                onChange={(e) => {
                                    if ((e.target.files || []).length <= 0) {
                                        e.target.value = '';
                                        return false;
                                    }
                                    const { requestObj, newComment } = this.state
                                    if (requestObj.rowID > 0) {
                                        newComment.attachments = [e.target.files[0]];
                                        this.setState({ newComment: { ...newComment } });
                                    } else {
                                        requestObj.attachments = [e.target.files[0]];
                                        this.setState({ requestObj: { ...requestObj } });
                                    }

                                    // requestObj.attachments.push(e.target.files[0]);
                                    // this.setState({requestObj:{...requestObj}});
                                    //e.target.value='';
                                    return true;
                                    //} 
                                }} />
                        </div>}
                    </div>
                    <div className='row'>
                        <div className='form-group text-right'>
                            <button className="btn btn-danger btn-sm" onClick={() => { this.cancelRequestForm() }}
                                type="submit" style={{ margin: 0, fontSize: 14 }}>Cancel
                            </button>&nbsp;&nbsp;
                            <button className="btn btn-success btn-sm" onClick={(e) => {
                                if (requestObj.rowID > 0) {
                                    this.handleSave(e);
                                } else {
                                    this.handleSubmit(e);
                                }
                            }}
                                type="submit" style={{ margin: '0 0 5px 0px', fontSize: 14 }} disabled={disablebtn}>Save
                            </button>

                        </div>
                    </div>
                </form>

            </div>
        </div>
        )
    }


    getColumns = () => {
        const columns = [
            {
                Header: 'Id',
                id: 'id',
                filterMethod: (filter, row) => {
                    const recId = row._original._links.self.href.split("/").pop();
                    return recId == filter.value.toLowerCase();
                },
                Cell: ({ row }) => {
                    const recId = row._original._links.self.href.split("/").pop();
                    return (<Fragment>{recId}</Fragment>)
                },
                width: 50,
            },
            {
                Header: 'Title',
                accessor: 'title', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.title).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 150,
            },
            {
                Header: 'Description',
                accessor: 'description', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.description).toLowerCase().startsWith(filter.value.toLowerCase())
                },
            },
            /*  {
                 Header:'Latest Comment',
                 accessor:'comments', style:{textAlign:'left'},
                 filterMethod: (filter, row) => {
                     const comments = (row._original.comments)?row._original.comments:"";
                     return (comments).toLowerCase().startsWith(filter.value.toLowerCase())
                 },
             }, */
            {
                Header: 'Issue',
                accessor: 'typeValue', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.typeValue).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 120,
            },
            {
                Header: 'Status',
                accessor: 'statusValue', style: { textAlign: 'center' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.statusValue).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 100,
            },
            /*   {
                  Header:'File',
                  accessor:' fileName', style:{textAlign:'center'},
                  width: 100,
                  Cell: ({row}) => (<div >
                      <a title={row._original.fileName} href={row._original.downloadUri}
                         target='_blank'
                         className="fa fa-file-image-o fa-2x"><i/></a>
                  </div>)
               }, */
            {
                Header: 'Created By',
                accessor: 'createdBy', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original
                    return (_row.createdBy).toLowerCase().startsWith(filter.value.toLowerCase())
                },
            },
            {
                Header: 'Created Time',
                accessor: 'createdOn', style: { textAlign: 'left' },
                filterMethod: (filter, row) => {
                    const _row = row._original;
                    return (_row.createdOn).toLowerCase().startsWith(filter.value.toLowerCase())
                },
                width: 150,
            },
            {
                Header: 'ACTIONS',
                style: { textAlign: 'center' },
                width: 100,
                filterable: false,
                Cell: ({ row }) => (<div>
                    <a title="Edit Request info" onClick={() => this.editReqestForm(row._original)}><i
                        className="fa fa-pencil-square-o tbl-rounded-icon bg-color-1 fa-icon" /></a>
                </div>)
            }
        ];
        return columns;
    }

    renderSupportList = () => {
        const { toggleSelection, toggleAll, isSelected } = this;
        const checkboxProps = {
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold', textAlign: 'right'
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    style: {
                        margin: 'auto !important'
                    },
                    className: "table table-hover"
                }
            },
        };
        return (
            <div className='row'>
                <div className='col-md-12'>
                    <ReactTable
                        filterable
                        data={this.state.recList}
                        //expanded={this.state.expanded}
                        columns={this.getColumns()}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        noDataText='No data found'
                        sortable={true}
                        defaultSorting={[{
                            id: 'session',
                            desc: false
                        }]}
                        minRows={1}
                        {...checkboxProps}
                    />

                </div>
            </div>
        )
    }
    render() {
        const { showList } = this.state;
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                            <h2>
                                <span>Support Request</span>
                            </h2>
                        </div>
                        {showList && <div className="col-md-6 col-sm-12 col-xs-12">
                            <button className="btn btn-success button-sm add-btn-sm"
                                onClick={(e) => this.showReqestForm()}><i className="fa fa-plus" /> New Request</button>
                        </div>}
                    </div>
                    <div className='row'>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            {
                                !showList ?
                                    this.renderNewRequestForm()
                                    :
                                    this.renderSupportList()
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ContactUS;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/contactUs/contactUs.jsx